<h4 *ngIf="title">{{title}}</h4>
<ng-template [ngIf]="esitoSpedizioneForm">
<form [formGroup]="esitoSpedizioneForm" (ngSubmit)="update();">
	<div class="row">
		<div datePickerInput class="col-sm-4 obbligatorio"
			[labelInput]="'Data spedizione'" formControlName="dataSpedizione"
			[(ngModel)]="esitoSpedizione.dataSpedizione" [mandatory]="true"
			[control]="esitoSpedizioneForm.controls['dataSpedizione']"></div>
		
		<div comboModInput [control]="esitoSpedizioneForm.controls['tipoEsitoSpedizione']"
			[mandatory]="true" class="col-sm-4 obbligatorio" [labelInput]="'Esito spedizione'"
			formControlName="tipoEsitoSpedizione"
			[objectReference]="esitoSpedizione.tipoEsitoSpedizione"
			(onReturn)="gestisciNuovoTipoEsito($event)"
			[optionsCombo] ="tipiEsitoSpedizione" [ngModel]="esitoSpedizione.tipoEsitoSpedizione"></div>

		<div comboModInput [control]="esitoSpedizioneForm.controls['motivoEsitoSpedizione']"
			class="col-sm-4" [labelInput]="'Motivo esito negativo'"
			formControlName="motivoEsitoSpedizione"
			[objectReference]="esitoSpedizione.motivoEsitoSpedizione"
			(onReturn)="esitoSpedizione.motivoEsitoSpedizione = $event"
			[ngModel]="esitoSpedizione.motivoEsitoSpedizione"
			[submitPending]="!esitoSpedizione.tipoEsitoSpedizione || esitoSpedizione.tipoEsitoSpedizione.id != idTipoEsitoSpedizioneNegativo " 
			[optionsCombo] ="motiviEsitoSpedizione"></div>
	</div>
	<div class="row">
		<div textAreaInput class="col-sm-12" [labelInput]="'Note'"
			formControlName="note" [(ngModel)]="esitoSpedizione.note"></div>
	</div>
	<div class="row">
		<p class="mandatory col-sm-12">
			<em>* Campi obbligatori</em>
		</p>
	</div>
	<div class="row">
		<p class="col-sm-3 col-xs-6">
			<button type="button" class="btn btn-outline-secondary btn-block"
				(click)="createForm();">Reset</button>
		</p>
		<p submitButton
			class="col-sm-3 col-xs-6 col-sm-offset-6"
			[disabled]="!esitoSpedizioneForm.valid"
			[labelButton]="'Salva'">
	</div>
</form>
</ng-template>
